export default __webpack_public_path__ + "static/media/writing.e5e36363.svg";